import React from 'react';
import { Link } from 'react-router-dom';
import translations from '../locale/fi.json';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-wave">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
                    <path fill="var(--brand-pink-light)" fillOpacity="1" d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,149.3C672,149,768,203,864,213.3C960,224,1056,192,1152,165.3C1248,139,1344,117,1392,106.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                </svg>
            </div>
            <div className="footer-content"> 
                <div className="footer-logo">
                    <img src="/logo512.png" alt="Jalkojesi Tähden" className="footer-logo-img" />
                </div>
                <div className="footer-info">
                    <h3>{translations.footer.title}</h3>
                    <div className="footer-address">
                        <p>{translations.footer.street}</p>
                        <p>{translations.footer.city}</p>
                        <p>{translations.footer.phone}</p>
                        <p>{translations.footer.email}</p>
                        <p>{translations.footer.ytunnus}</p>
                    </div>
                </div>
                
                <div className="footer-navigation">
                    <h3>{translations.footer.navigaatio}</h3>
                    <div className="footer-links">
                        <Link to="/">{translations.footer.home}</Link>
                        <Link to="/palvelut-ja-hinnasto">{translations.footer.servicepricing}</Link>
                        <Link to="/yhteystiedot">{translations.footer.contact}</Link>
                        <Link to="/tietosuoja">{translations.footer.privacy}</Link>
                    </div>
                </div>
                
                <div className="footer-hours">
                    <h3>{translations.footer.openinghoursTitle}</h3>
                    <p>{translations.footer.openinghoursWeek}</p>
                    <p>{translations.footer.openinghoursWeekend1}</p>
                    <p>{translations.footer.openinghoursWeekend2}</p>
                </div>

                <div className="footer-social">
                    <h3>{translations.footer.followus}</h3>
                    <a href="https://www.facebook.com/p/Jalkojesi-T%C3%A4hden-100083000333580/" target="_blank" rel="noopener noreferrer">{translations.footer.facebook}</a>
                </div>
            </div>
            
            <div className="footer-copyright">
                <p>{translations.footer.copyright}</p>
            </div>
        </footer>
    );
}

export default Footer;

